import {NgModule} from '@angular/core';
import {CoreModule} from '../core/core.module';
import {ThuisverzorgersComponent} from './thuisverzorgers/thuisverzorgers.component';
import {UpsertThuisverzorgerComponent} from './upsert-thuisverzorger/upsert-thuisverzorger.component';
import {ZoneModule} from '../zone/zone.module';
import {DienstModule} from '../dienst/dienst.module';
import {ThuisverzorgerDienstenPipe} from "./thuisverzorger-diensten.pipe";

@NgModule({
  declarations: [
    ThuisverzorgersComponent,
    UpsertThuisverzorgerComponent,
    ThuisverzorgerDienstenPipe,
  ],
  imports: [
    CoreModule,
    ZoneModule,
    DienstModule
  ],
  exports: [
    ThuisverzorgersComponent,
    UpsertThuisverzorgerComponent,
  ],
})
export class ThuisverzorgerModule {
}
